function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { withScope, captureException } from "@sentry/browser";
import { getCorrelationId, getJSessionId, getUsrLocale, getIsLoggedIn, getOktaSession } from "../utils";
/**
 * The Logger class is used to log errors to Sentry.
 * You should create a new Logger instance for each application you have.
 * In monorepo projects, this means every package should have its own Logger instance.
 * In federated projects, this means every app should have its own Logger instance.
 */ export var Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger(param) {
        var owner = param.owner, app = param.app, release = param.release;
        this.owner = owner;
        this.app = app;
        this.release = release;
    }
    var _proto = Logger.prototype;
    /**
   * Sets the required tags for the error. These tags are mostly used for routing errors to correct projects and
   * for governance when using alerts from Sentry.
   * @param scope Sentry Scope
   * @private
   */ _proto.setRequiredTags = function setRequiredTags(scope) {
        scope.setTag("owner", this.owner);
        scope.setTag("app", this.app);
        scope.setTag("release", this.release);
    };
    /**
   * Set the base tags for the error.
   * These tags are used to help identify the source of the error.
   * Base tags are required and automatically added.
   * @param scope The Sentry scope object
   * @param req The request object for Express or Fastify
   * @private
   */ _proto.setBaseTags = function setBaseTags(scope, req) {
        // Correlation ID is used for tracking a request through the system
        scope.setTag("correlationId", getCorrelationId(req));
        // jSessionId is used for tracking a user session
        scope.setTag("jSessionId", getJSessionId(req));
        // Locale is used for tracking the user's locale
        scope.setTag("locale", getUsrLocale(req));
        // isLoggedIn is used for tracking if the user is logged in
        scope.setTag("isLoggedIn", getIsLoggedIn(req));
        // oktaSession is used for tracking if the user has an Okta session
        scope.setTag("hasOktaSession", getOktaSession(req));
    };
    /**
   * Set the recommended tags for the error.
   * These tags are used to help identify the source of the error.
   * Recommended tags are not required.
   * If you do not provide recommended tags, they will not be set.
   * @param scope The Sentry scope object
   * @param componentName The name of the component where the error occurred
   * @param functionName The name of the function where the error occurred
   * @param featureName The name of the feature where the error occurred
   * @private
   */ _proto.setTags = function setTags(scope, _param) {
        var componentName = _param.componentName, functionName = _param.functionName, featureName = _param.featureName, tags = _object_without_properties_loose(_param, [
            "componentName",
            "functionName",
            "featureName"
        ]);
        scope.setTag("componentName", componentName);
        scope.setTag("functionName", functionName);
        scope.setTag("featureName", featureName);
        Object.entries(tags).forEach(function(param) {
            var _$_param = _sliced_to_array(param, 2), key = _$_param[0], value = _$_param[1];
            scope.setTag(key, value);
        });
    };
    /**
   * Set the extra context for the error.
   * This information is used to add more data to the user session when the error occurred.
   * @private
   * @param scope The Sentry scope object
   * @param context A series of Context objects that contain the extra information
   */ _proto.setContext = function setContext(scope, context) {
        Object.entries(context).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            scope.setContext(key, value);
        });
    };
    /**
   * Set the API tags for the error. We use this method if the error is from an API call.
   * These tags are used to help identify the source of the error.
   * API tags are not required.
   * If you do not provide API tags, they will not be set.
   * @param scope
   * @param apiContext
   * @private
   */ _proto.setApiTags = function setApiTags(scope, apiContext) {
        var _apiContext_url = apiContext.url, url = _apiContext_url === void 0 ? "unknown" : _apiContext_url, method = apiContext.method, service = apiContext.service, responseBody = apiContext.responseBody, query = apiContext.query, _apiContext_statusCode = apiContext.statusCode, statusCode = _apiContext_statusCode === void 0 ? "unknown" : _apiContext_statusCode;
        scope.setTag("errorType", "API Error");
        scope.setTag("statusCode", statusCode);
        scope.setTag("requestUrl", url);
        scope.setTag("method", method);
        scope.setTag("service", service);
        if (url.includes("graphql") && !query) {
            this.debug("No query provided for GraphQL API call. Consider adding one to the error.");
        } else {
            scope.setTag("query", query);
        }
        scope.setContext("API Context", {
            url: url,
            query: query,
            method: method,
            service: service,
            responseBody: responseBody,
            statusCode: statusCode
        });
        scope.setFingerprint([
            method,
            url,
            statusCode
        ]);
    };
    /**
   * Debug logs will only show up in the browser console in development.
   * Use this method to log information that is useful for developers to debug the application.
   * Debug logs are not sent to Sentry. They are only logged to the console.
   * @param message What you want to log
   * @param extra Any extra information you want to log
   */ _proto.debug = function debug(message, extra) {
        if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
            if (extra) {
                console.debug(message, extra);
            } else console.debug(message);
        }
    };
    /**
   * Info logs will show up in the browser console in production.
   * Use this method to log information that is useful for developers to debug the application.
   * Info logs are not sent to Sentry. They are only logged to the console.
   * @param message What you want to log
   * @param extra Any extra information you want to log
   */ _proto.info = function info(message, extra) {
        if (extra) {
            console.info(message, extra);
        } else console.info(message);
    };
    /**
   * This is the base error method that should be used for most errors.
   * It will automatically add required tags such as correlationId and locale.
   * It will also automatically add recommended tags if provided.
   * @param error The original error object, or a new Error object (new Error('message'))
   * @param errorContext The context object that contains the request and recommended tags
   * @param callback A callback function that will be called with the scope object, used to add extra context.
   */ _proto.error = function error(error, errorContext, callback) {
        if (errorContext === void 0) errorContext = {};
        var _this = this;
        var req = errorContext.req, _errorContext_severity = errorContext.severity, severity = _errorContext_severity === void 0 ? "error" : _errorContext_severity, tags = errorContext.tags, apiContext = errorContext.apiContext, fingerprint = errorContext.fingerprint, context = errorContext.context;
        withScope(function(scope) {
            // Set the required tags for routing on Sentry
            _this.setRequiredTags(scope);
            // Set the base required tags for all errors.
            _this.setBaseTags(scope, req);
            // Set the severity level for the error.
            scope.setLevel(severity);
            // Set the recommended tags for the error if provided.
            if (tags) _this.setTags(scope, tags);
            else {
                _this.debug("No recommended context provided, consider adding more information to the error.");
            }
            // Set the API tags for the error if provided. This is used for API errors only.
            if (apiContext) _this.setApiTags(scope, apiContext);
            // Set the extra context for the error if provided.
            if (context) _this.setContext(scope, context);
            // Set the fingerprint for the error if provided. This is used for grouping errors together.
            if (fingerprint) scope.setFingerprint(fingerprint);
            else if (!apiContext) {
                _this.debug("No fingerprint provided, consider adding one to the error.", {
                    errorContext: errorContext
                });
            }
            // Call the callback function with the scope object, used to add extra context.
            if (callback) callback(scope);
            if (severity === "warning") console.warn(error);
            else console.error(error);
            // Capture the error and send to Sentry.
            captureException(error);
        });
    };
    /**
   * Helper method to capture a warning error. This will automatically set the severity to warning.
   * Use warnings for errors that should not trigger an alert, but should be logged.
   * @param error The original error object, or a new Error object (new Error('message'))
   * @param errorContext The context object that contains the request and recommended tags
   * @param callback A callback function that will be called with the scope object, used to add extra context.
   */ _proto.warn = function warn(error, errorContext, callback) {
        this.error(error, _extends({}, errorContext, {
            severity: "warning"
        }), callback);
    };
    /**
   * Helper method to capture a warning error. This will automatically set the severity to fatal.
   * Use fatal for errors that should trigger an alert immediatelly, and should be logged.
   * @param error The original error object, or a new Error object (new Error('message'))
   * @param errorContext The context object that contains the request and recommended tags
   * @param callback A callback function that will be called with the scope object, used to add extra context.
   */ _proto.fatal = function fatal(error, errorContext, callback) {
        this.error(error, _extends({}, errorContext, {
            severity: "fatal"
        }), callback);
    };
    return Logger;
}();
export default Logger;
